import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

  transform(arr: any[], key: string): string {
    let res: any[] = [];
    arr.forEach((item: any) => {
      if (res.indexOf(item[key]) === -1) {
        res.push(item[key]);
      }
    })
    return res.join(', ');
  }

}
